import { getUserInfo } from "@/api/user";
import router from "@/router";
import toast from "@/utils/toast";
import { removeToken, setToken } from "@/utils/auth";
import { authLogin } from "@/api/login";
import { getUrlParameters } from "@/utils/url";

const ML_REGISTER = "ML_REGISTER";

export default {
  namespaced: true,
  state: {
    avatar: null,
    gender: null,
    goddessInfoRes: null,
    id: null,
    nickname: null,
    phone: null,
    role: null,
    vipDay: null,
    vipName: null,
    watchNumber: null
  },
  getters: {
    logged: state => state.id !== null,
    isVip: state => state.vipName === "黄金vip" || state.vipName === "砖石vip",
    isMasonryVip: state => state.vipName === "砖石vip"
  },
  mutations: {
    SET_AVATAR(state, data) {
      state.avatar = data;
    },
    SET_GENDER(state, data) {
      state.gender = data;
    },
    SET_GODDESS_INFO_RES(state, data) {
      state.goddessInfoRes = data;
    },
    SET_ID(state, data) {
      state.id = data;
    },
    SET_NICKNAME(state, data) {
      state.nickname = data;
    },
    SET_PHONE(state, data) {
      state.phone = data;
    },
    SET_ROLE(state, data) {
      state.role = data;
    },
    SET_VIP_DAY(state, data) {
      state.vipDay = data;
    },
    SET_VIP_NAME(state, data) {
      state.vipName = data;
    }
  },
  actions: {
    async login({ dispatch }, { username, code }) {
      try {
        const token = await authLogin(username, code);
        setToken(token);
        await dispatch("getInfo");
        const isRegistered = localStorage.getItem(ML_REGISTER);
        // 首次登录
        if (!isRegistered) {
          await router.push({
            name: "userEditor",
            params: { firstLogin: true }
          });
          localStorage.setItem(ML_REGISTER, "1");
          return;
        }
        // 非首次登录
        const { redirect } = getUrlParameters();
        if (redirect) {
          await router.push({
            path: redirect
          });
        } else {
          await router.push({ name: "home" });
        }
        toast("登录成功");
      } catch (e) {
        toast("登录失败", 1000);
        console.error(e);
      }
    },
    async getInfo({ commit }) {
      try {
        const {
          avatar,
          gender,
          goddessInfoRes,
          id,
          nickname,
          phone,
          role,
          vipDay,
          vipName
        } = await getUserInfo();
        commit("SET_AVATAR", avatar);
        commit("SET_GENDER", gender);
        commit("SET_GODDESS_INFO_RES", goddessInfoRes);
        commit("SET_ID", id);
        commit("SET_NICKNAME", nickname);
        commit("SET_PHONE", phone);
        commit("SET_ROLE", role);
        commit("SET_VIP_DAY", vipDay);
        commit("SET_VIP_NAME", vipName);
      } catch (e) {
        await router.push({ name: "login" });
        removeToken();
        toast("获取个人信息有误，请重新登录", 1000);
        console.error(e);
      }
    },
    async logout({ commit }) {
      commit("SET_AVATAR", null);
      commit("SET_GENDER", null);
      commit("SET_GODDESS_INFO_RES", null);
      commit("SET_ID", null);
      commit("SET_NICKNAME", null);
      commit("SET_PHONE", null);
      commit("SET_ROLE", null);
      commit("SET_VIP_DAY", null);
      commit("SET_VIP_NAME", null);
      removeToken();
    }
  }
};
